const IMLocationLookupLayout = (customParams = {}) => ({
    valueExpr: 'id',
    displayExpr: 'codevalue',
    sort: [{ selector: "codevalue", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: 'F91D413B-D76F-4E99-8CC4-289D69AE5D44',
    params: {
        module: "im",
        lookupType: "IMLocation",
        showLookupGrid: true,
        ...customParams
    },
    columns: [
        { dataField: "codevalue", caption: "Location", dataType: "string"  },
        { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime" , visible: false },
        { dataField: "creationuserid", caption: "Created By", dataType: "string" , visible: false },
        { dataField: "lastupdatedatetime", caption: "Last Updated Date", dataType: "datetime" , visible: false },
        { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string" , visible: false },
        { dataField: "identityid", caption: "Warehouse", dataType: "string"  },
        { dataField: "description", caption: "Description", dataType: "string"  },
        { dataField: "status", caption: "Status", dataType: "string" , visible: false },
        { dataField: "dimensions", caption: "Dimensions", dataType: "string" , visible: false },
        { dataField: "classcode", caption: "Class Code", dataType: "string" , visible: false },
        { dataField: "subclasscode", caption: "Subclass Code", dataType: "string" , visible: false },
        { dataField: "userdefinedcode_1", caption: "Code 1", dataType: "string" , visible: false },
        { dataField: "userdefinedcode_2", caption: "Code 2", dataType: "string" , visible: false },
        { dataField: "userdefinedcode_3", caption: "Code 3", dataType: "string" , visible: false },
        { dataField: "userdefinedcode_4", caption: "Code 4", dataType: "string" , visible: false },
        { dataField: "userdefinedcode_5", caption: "Code 5", dataType: "string" , visible: false },
        { dataField: "userdefinedcode_6", caption: "Code 6", dataType: "string" , visible: false },
        { dataField: "userdefinedcode_7", caption: "Code 7", dataType: "string" , visible: false },
        { dataField: "userdefinedcode_8", caption: "Code 8", dataType: "string" , visible: false },
        { dataField: "userdefinedcode_9", caption: "Code 9", dataType: "string" , visible: false },
        { dataField: "userdefinedcode_10", caption: "Code 10", dataType: "string" , visible: false },
        { dataField: "userdefinedreference_1", caption: "Reference 1", dataType: "string" , visible: false },
        { dataField: "userdefinedreference_2", caption: "Reference 2", dataType: "string" , visible: false },
        { dataField: "userdefinedreference_3", caption: "Reference 3", dataType: "string" , visible: false },
        { dataField: "userdefinedreference_4", caption: "Reference 4", dataType: "string" , visible: false },
        { dataField: "userdefinedreference_5", caption: "Reference 5", dataType: "string" , visible: false },
        { dataField: "userdefinedreference_6", caption: "Reference 6", dataType: "string" , visible: false },
        { dataField: "userdefinedreference_7", caption: "Reference 7", dataType: "string" , visible: false },
        { dataField: "userdefinedreference_8", caption: "Reference 8", dataType: "string" , visible: false },
        { dataField: "userdefinedreference_9", caption: "Reference 9", dataType: "string" , visible: false },
        { dataField: "userdefinedreference_10", caption: "Reference 10", dataType: "string" , visible: false },
        { dataField: "userdefineddate_1", caption: "Date 1", dataType: "date" , visible: false },
        { dataField: "userdefineddate_2", caption: "Date 2", dataType: "date" , visible: false },
        { dataField: "userdefineddate_3", caption: "Date 3", dataType: "date" , visible: false },
        { dataField: "userdefineddate_4", caption: "Date 4", dataType: "date" , visible: false },
        { dataField: "userdefineddate_5", caption: "Date 5", dataType: "date" , visible: false },
        { dataField: "userdefineddate_6", caption: "Date 6", dataType: "date" , visible: false },
        { dataField: "userdefineddate_7", caption: "Date 7", dataType: "date" , visible: false },
        { dataField: "userdefineddate_8", caption: "Date 8", dataType: "date" , visible: false },
        { dataField: "userdefineddate_9", caption: "Date 9", dataType: "date" , visible: false },
        { dataField: "userdefineddate_10", caption: "Date 10", dataType: "date" , visible: false },
        { dataField: "userdefinedquantity_1", caption: "Quantity 1", dataType: "number" , visible: false },
        { dataField: "userdefinedquantity_2", caption: "Quantity 2", dataType: "number" , visible: false },
        { dataField: "userdefinedquantity_3", caption: "Quantity 3", dataType: "number" , visible: false },
        { dataField: "userdefinedquantity_4", caption: "Quantity 4", dataType: "number" , visible: false },
        { dataField: "userdefinedquantity_5", caption: "Quantity 5", dataType: "number" , visible: false },
        { dataField: "userdefinedquantity_6", caption: "Quantity 6", dataType: "number" , visible: false },
        { dataField: "userdefinedquantity_7", caption: "Quantity 7", dataType: "number" , visible: false },
        { dataField: "userdefinedquantity_8", caption: "Quantity 8", dataType: "number" , visible: false },
        { dataField: "userdefinedquantity_9", caption: "Quantity 9", dataType: "number" , visible: false },
        { dataField: "userdefinedquantity_10", caption: "Quantity 10", dataType: "number" , visible: false },
        { dataField: "height", caption: "Height", dataType: "number" , visible: false },
        { dataField: "width", caption: "Width", dataType: "number" , visible: false },
        { dataField: "depth", caption: "Depth", dataType: "number" , visible: false}
    ]
});
const IMKitHeaderLookupLayout = (customParams = {}) => ({
    valueExpr: 'id',
    displayExpr: 'codevalue',
    sort: [{ selector: "codevalue", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: 'E1A5C584-79D0-40B2-96EF-3B28DB6D57DF',
    params: {
        module: "im",
        lookupType: "IMKitHeader",
        showLookupGrid: true,
        ...customParams
    },
    columns: [
        { dataField: "id", caption: "ID", dataType: "string", visible: false , visible: false },
        { dataField: "codevalue", caption: "Kit Code", dataType: "string"  },
        { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime" , visible: false },
        { dataField: "creationuserid", caption: "Created By", dataType: "string" , visible: false },
        { dataField: "lastupdatedatetime", caption: "Last Updated Date", dataType: "datetime" , visible: false },
        { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string" , visible: false },
        { dataField: "description", caption: "Description", dataType: "string"  },
        { dataField: "status", caption: "Status", dataType: "string" , visible: false },
    ]
});

const ImItemLookupLayout = (customParams = {}) => ({
    valueExpr: 'Id',
    displayExpr: 'Name',
    sort: [{ selector: "Name", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '813A4632-08DA-4C4D-942A-2C3DE387E655',
    params: {
        module: "im",
        lookupType: "ImItem",
        showLookupGrid: true,
        ...customParams,
        isPascalCase:true
    },
    columns: [
        { dataField: "Id", caption: "ID", dataType: "string", visible: false , visible: false },
        { dataField: "WareHouse", caption: "WareHouse", dataType: "string" },
        { dataField: "Name", caption: "Item", dataType: "string" },
        { dataField: "Customer", caption: "Customer", dataType: "string" },
        { dataField: "Description1", caption: "Description1", dataType: "string" },
        { dataField: "Description2", caption: "Description2", dataType: "string" },
        { dataField: "ItemType", caption: "Item Type", dataType: "string" },
        { dataField: "OmkitFlag", caption: "Om kit Flag", dataType: "string" },
        { dataField: "PmkitFlag", caption: "Pm kit Flag", dataType: "string" },
        { dataField: "WarrantyFlag", caption: "Warranty Flag", dataType: "string" },
        { dataField: "WarrantyMonths", caption: "Warranty Months", dataType: "string" },
        { dataField: "RoundingFactor", caption: "Rounding Factor", dataType: "string" },
        { dataField: "PhysicalCountCode", caption: "Physical Count Code", dataType: "string" },
        { dataField: "PriceMethod", caption: "Price Method", dataType: "string" },
        { dataField: "PriceBasis", caption: "Price Basis", dataType: "string" },
        { dataField: "Profile", caption: "Profile", dataType: "string" },
       
    ]
});

const IMPriceScheduleLookupLayout = (customParams = {}) => ({
    valueExpr: 'id',
    displayExpr: 'name',
    sort: [{ selector: "name", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '3A1A96D0-2D40-4EE5-8419-F14C8770BE27',
    params: {
        module: "im",
        lookupType: "PriceScheduale",
        showLookupGrid: true,
        ...customParams
    },
    columns: [
        { dataField: "id", caption: "ID", dataType: "string", visible: false , visible: false },
        { dataField: "name", caption: "Price Sched", dataType: "string"  },
        { dataField: "priceLevel", caption: "Price Level", dataType: "string"  },
        { dataField: "description", caption: "Description", dataType: "string"   },
        { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime" , visible: false },
        { dataField: "creationuserid", caption: "Created By", dataType: "string" , visible: false },
        { dataField: "lastupdatedatetime", caption: "Last Updated Date", dataType: "datetime" , visible: false },
        { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string" , visible: false },
        { dataField: "recordnumber", caption: "Record#", dataType: "string"  , visible: false },
        { dataField: "companyid", caption: "Company ID", dataType: "string"  , visible: false },
        { dataField: "module", caption: "Module", dataType: "string"  , visible: false },
        { dataField: "recordtype", caption: "Record Type", dataType: "string"  , visible: false },
        { dataField: "status", caption: "Status", dataType: "string"  , visible: false },
        { dataField: "usediscount", caption: "Use Discount", dataType: "string"  , visible: false },
        { dataField: "allowdiscount", caption: "Allow Discount", dataType: "number"  , visible: false },
    ]
});
const IMFeesLookupLayout =  {
    valueExpr: 'rowid',
    displayExpr: 'miscfeecode',
    sort: [{ selector: "miscfeecode", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: 'F87F2CA8-503A-41E6-BB1B-803FD28F5CEF',
    params: {
        module: "im",
        lookupType: "ImFees",
        showLookupGrid: true,
    },
    columns: [
{visible:false, dataField: "creationdatetime", caption: "Creation date time", dataType: "datetime"  },
{visible:false, dataField: "recordnumber", caption: "Record#", dataType: "string"  },
{visible:false, dataField: "creationuserid", caption: "Creation user id", dataType: "string"  },
{visible:false, dataField: "lastupdatedatetime", caption: "Last update date time", dataType: "datetime"  },
{visible:false, dataField: "lastupdateuserid", caption: "Last update user id", dataType: "string"  },
{visible:false, dataField: "status", caption: "Status", dataType: "string"  },
{dataField: "miscfeecode", caption: "Miscfeecode", dataType: "string"  },
{dataField: "description", caption: "Description", dataType: "string"  },
{visible:false, dataField: "userdefinedcode1", caption: "Code 1", dataType: "string"  },
{visible:false, dataField: "userdefinedcode2", caption: "Code 2", dataType: "string"  },
{visible:false, dataField: "userdefinedcode3", caption: "Code 3", dataType: "string"  },
{visible:false, dataField: "userdefinedcode4", caption: "Code 4", dataType: "string"  },
{visible:false, dataField: "userdefinedcode5", caption: "Code 5", dataType: "string"  },
{visible:false, dataField: "userdefineddate1", caption: "Date 1", dataType: "date"  },
{visible:false, dataField: "userdefineddate2", caption: "Date 2", dataType: "date"  },
{visible:false, dataField: "userdefineddate3", caption: "Date 3", dataType: "date"  },
{visible:false, dataField: "userdefineddate4", caption: "Date 4", dataType: "date"  },
{visible:false, dataField: "userdefineddate5", caption: "Date 5", dataType: "date"  },
{visible:false, dataField: "userdefinedquantity1", caption: "Quantity 1", dataType: "number"  },
{visible:false, dataField: "userdefinedquantity2", caption: "Quantity 2", dataType: "number"  },
{visible:false, dataField: "userdefinedquantity3", caption: "Quantity 3", dataType: "number"  },
{visible:false, dataField: "userdefinedquantity4", caption: "Quantity 4", dataType: "number"  },
{visible:false, dataField: "userdefinedquantity5", caption: "Quantity 5", dataType: "number"  },
{visible:false, dataField: "userdefinedreference1", caption: "Reference 1", dataType: "string"  },
{visible:false, dataField: "userdefinedreference2", caption: "Reference 2", dataType: "string"  },
{visible:false, dataField: "userdefinedreference3", caption: "Reference 3", dataType: "string"  },
{visible:false, dataField: "userdefinedreference4", caption: "Reference 4", dataType: "string"  },
{visible:false, dataField: "userdefinedreference5", caption: "Reference 5", dataType: "string"  },

    ]
}
const MandateFeesLookupLayout =  {
    valueExpr: 'Id',
    displayExpr: 'Code',
    sort: [{ selector: "Code", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: 'CE8C35F8-BFA1-4510-B84F-08A468AB4AFE',
    params: {
        module: "im",
        lookupType: "MandateFees",
        showLookupGrid: true,
        isPascalCase:true,
    },
    columns: [
         {visible:false, dataField: "CreationDateTime", caption: "Creation date time", dataType: "datetime"  },
         {visible:false, dataField: "RecordNumber", caption: "Record#", dataType: "string"  },
         {visible:false, dataField: "CreationUserId", caption: "Creation user id", dataType: "string"  },
         {visible:false, dataField: "LastUpdateDateTime", caption: "Last update date time", dataType: "datetime"  },
         {visible:false, dataField: "LastUpdateUserId", caption: "Last update user id", dataType: "string"  },
         {visible:false, dataField: "Status", caption: "Status", dataType: "string"  },
         {dataField: "Code", caption: "Mandated Fee Code", dataType: "string"  },
         {dataField: "Description", caption: "Description", dataType: "string"  },
         {visible:false, dataField: "UserDefinedCode1", caption: "Code 1", dataType: "string"  },
         {visible:false, dataField: "UserDefinedCode2", caption: "Code 2", dataType: "string"  },
         {visible:false, dataField: "UserDefinedCode3", caption: "Code 3", dataType: "string"  },
         {visible:false, dataField: "UserDefinedCode4", caption: "Code 4", dataType: "string"  },
         {visible:false, dataField: "UserDefinedCode5", caption: "Code 5", dataType: "string"  },
         {visible:false, dataField: "UserDefinedDate1", caption: "Date 1", dataType: "date"  },
         {visible:false, dataField: "UserDefinedDate2", caption: "Date 2", dataType: "date"  },
         {visible:false, dataField: "UserDefinedDate3", caption: "Date 3", dataType: "date"  },
         {visible:false, dataField: "UserDefinedDate4", caption: "Date 4", dataType: "date"  },
         {visible:false, dataField: "UserDefinedDate5", caption: "Date 5", dataType: "date"  },
         {visible:false, dataField: "UserDefinedQuantity1", caption: "Quantity 1", dataType: "number"  },
         {visible:false, dataField: "UserDefinedQuantity2", caption: "Quantity 2", dataType: "number"  },
         {visible:false, dataField: "UserDefinedQuantity3", caption: "Quantity 3", dataType: "number"  },
         {visible:false, dataField: "UserDefinedQuantity4", caption: "Quantity 4", dataType: "number"  },
         {visible:false, dataField: "UserDefinedQuantity5", caption: "Quantity 5", dataType: "number"  },
         {visible:false, dataField: "UserDefinedReference1", caption: "Reference 1", dataType: "string"  },
         {visible:false, dataField: "UserDefinedReference2", caption: "Reference 2", dataType: "string"  },
         {visible:false, dataField: "UserDefinedReference3", caption: "Reference 3", dataType: "string"  },
         {visible:false, dataField: "UserDefinedReference4", caption: "Reference 4", dataType: "string"  },
         {visible:false, dataField: "UserDefinedReference5", caption: "Reference 5", dataType: "string"  },

    ]
}
const IMProductCategoryLookupLayout = (customParams = {}) => ({
    valueExpr: 'id',
    displayExpr: 'name',
    sort: [{ selector: "name", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: 'A4F4E780-6E9A-4145-BFF6-B679FC48F105',
    params: {
        module: "im",
        lookupType: "ProductCategory",
        showLookupGrid: true,
        ...customParams
    },
    columns: [
        { dataField: "id", caption: "ID", dataType: "string", visible: false , visible: false },
        { dataField: "name", caption: "Product Category", dataType: "string"  },
        { dataField: "description", caption: "Description", dataType: "string"   },
        { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime" , visible: false,format:'MM/dd/yyyy hh:mm:ss a' },
        { dataField: "creationuserid", caption: "Created By", dataType: "string" , visible: false, format:'MM/dd/yyyy hh:mm:ss a' },
        { dataField: "lastupdatedatetime", caption: "Last Updated Date", dataType: "datetime" , visible: false, format:'MM/dd/yyyy hh:mm:ss a' },
        { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string" , visible: false },
        { dataField: "recordnumber", caption: "Record#", dataType: "string"  , visible: false },
        { dataField: "reference", caption: "Reference#", dataType: "string"  , visible: false },
        { dataField: "status", caption: "Status", dataType: "string"  , visible: false },
    ]
});

// IMTRANSACTIONDP - the Profile field on IM Transaction Entry (Delphi IMD0019 edtP_PROFILE, a
// TDBArgosLookupEdit over qryIMTransactionDP: typing allowed, AllowInvalid False, popup search on
// PROFILECODE, ShowAllRecords True). acceptCustomValue mirrors LockKeyboard False - the typed value
// still has to resolve to a record, which the lookup enforces.
const IMTransactionProfileLookupLayout = (customParams = {}) => ({
    valueExpr: 'id',
    displayExpr: 'name',
    sort: [{ selector: "name", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: 'B7C31E42-95A8-4D6F-8E2B-1A4C7D905F63',
    params: {
        module: "im",
        lookupType: "ImTransactionDp",
        showLookupGrid: true,
        ...customParams
    },
    columns: [
        { dataField: "id", caption: "ID", dataType: "string", visible: false },
        { dataField: "name", caption: "Profile", dataType: "string" },
        { dataField: "description", caption: "Description", dataType: "string" },
        { dataField: "keysequence", caption: "Record#", dataType: "string", visible: false },
        { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime", visible: false, format: 'MM/dd/yyyy hh:mm:ss a' },
        { dataField: "creationuserid", caption: "Created By", dataType: "string", visible: false },
        { dataField: "lastupdatedatetime", caption: "Last Updated Date", dataType: "datetime", visible: false, format: 'MM/dd/yyyy hh:mm:ss a' },
        { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string", visible: false },
    ]
});

const IMLotLookupLayout = (customParams = {}) => ({
    valueExpr: 'id',
    displayExpr: 'codevalue',
    sort: [{ selector: "codevalue", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: 'BA4DBF6E-6230-456A-B508-C954E9F8B8C0',
    params: {
        module: "im",
        lookupType: "ImLot",
        showLookupGrid: true,
        ...customParams
    },
    columns: [
        { dataField: "id", caption: "ID", dataType: "string", visible: false , visible: false },
        { dataField: "codevalue", caption: "Lot", dataType: "string"  },
        { dataField: "description1", caption: "Description-1", dataType: "string"  },
        { dataField: "description2", caption: "Description-2", dataType: "string" , visible: false },
    ]
});
const CodeLookupLayout =(customParams = {}) =>{
   return { valueExpr: 'name',
    displayExpr: 'name',
    sort: [{ selector: "name", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: 'BA4DBF6E-6230-456A-B508-C954E9F8B8C0',
    params: {
        module: "im",
        lookupType: "ImCode",
        showLookupGrid: true,
        codetype:customParams.codeType,
    },
    columns: [
        { dataField: "name", caption: "Code", dataType: "string" },
        { dataField: "description", caption: "Description", dataType: "string" },
        { dataField: "description2", caption: "Description 2", dataType: "string" , visible: false },
        { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime" , visible: false, format:'MM/dd/yyyy hh:mm:ss a'},
        { dataField: "creationuserid", caption: "Created By", dataType: "string" , visible: false },
        { dataField: "lastupdatedatetime", caption: "Last Updated Date", dataType: "datetime" , visible: false, format:'MM/dd/yyyy hh:mm:ss a' },
        { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string" , visible: false },
        { dataField: "codetype", caption: "Code Type", dataType: "string" , visible: false },
    ]
};
}
const LocationDpLookupLayout = (customParams = {}) =>{
   return {
    valueExpr: 'id',
    displayExpr: 'name',
    sort: [{ selector: "name", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: 'BA4DBF6E-6230-456A-B508-C954E9F8B8C0',
    params: {
        module: "im",
        lookupType: "LocationDp",
        showLookupGrid: true,
        ...customParams
    },
    columns: [
        { dataField: "name", caption: "Profile Code", dataType: "string" },
        { dataField: "description", caption: "Description", dataType: "string" },
        { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime" , visible: false },
        { dataField: "creationuserid", caption: "Created By", dataType: "string" , visible: false },
        { dataField: "lastupdatedatetime", caption: "Last Updated Date", dataType: "datetime" , visible: false },
        { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string" , visible: false },
        {visible:false, dataField: "userdefinedcode1", caption: "Code 1", dataType: "string"  },
        {visible:false, dataField: "userdefinedcode2", caption: "Code 2", dataType: "string"  },
        {visible:false, dataField: "userdefinedcode3", caption: "Code 3", dataType: "string"  },
        {visible:false, dataField: "userdefinedcode4", caption: "Code 4", dataType: "string"  },
        {visible:false, dataField: "userdefinedcode5", caption: "Code 5", dataType: "string"  },
    ]

}};
const ItemBuilderConfigLookup ={
    valueExpr: 'Id',
    displayExpr: 'Name',
    sort: [{ selector: "Name", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '6A78F267-6698-4191-830A-B14AAA98D633',
    params: {
        module: "im",
        isPascalCase:true,
        lookupType: "ItemBuilderConfig",
        showLookupGrid: true,
    },
    columns: [
        { dataField: "Record", caption: "Record #", dataType: "string"  },
        { dataField: "Name", caption: "Config Code", dataType: "string" },
        { dataField: "Description", caption: "Description", dataType: "string" },
        { dataField: "Reference", caption: "Reference", dataType: "string" },
        { dataField: "CreationDateTime", caption: "Creation Date", dataType: "datetime" , visible: false },
        { dataField: "CreationUserId", caption: "Created By", dataType: "string" , visible: false },
        { dataField: "LastUpdateDateTime", caption: "Last Updated Date", dataType: "datetime" , visible: false },
        { dataField: "LastUpdateUserId", caption: "Last Updated By", dataType: "string" , visible: false },
    ]
}
const CrateDPLookup =(customParams = {})=>{
    return {
    valueExpr: 'Id',
    displayExpr: 'Name',
    sort: [{ selector: "Name", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '6A78F267-6698-4191-830A-B14AAA98D634',
    params: {
        module: "im",
        isPascalCase:true,
        lookupType: "CrateDp",
        showLookupGrid: true,
        ...customParams
    },
    columns: [
        { dataField: "Record", caption: "Record #", dataType: "string"  },
        { dataField: "Name", caption: "Config Code", dataType: "string" },
        { dataField: "Description", caption: "Description", dataType: "string" },
        { dataField: "CreationDateTime", caption: "Creation Date", dataType: "datetime" , visible: false },
        { dataField: "CreationUserId", caption: "Created By", dataType: "string" , visible: false },
        { dataField: "LastUpdateDateTime", caption: "Last Updated Date", dataType: "datetime" , visible: false },
        { dataField: "LastUpdateUserId", caption: "Last Updated By", dataType: "string" , visible: false },
    ]
}
}
const ItemDpLookupLayout = {
    valueExpr: 'id',
    displayExpr: 'profilecode',
    sort: [{ selector: "profilecode", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '05119b3f-85aa-4e29-bb67-02caa19bbe9e',
    selectboxlabel: 'Profile',
    params: {
        module: "im",
        lookupType: "ImItemDp",
        showLookupGrid: true
    },
    columns:  [
        /* { dataField: "id", caption: "ID", dataType: "string", visible: false }, */
        { dataField: "profilecode", caption: "Profile Code", dataType: "string" },
        { dataField: "description", caption: "Description", dataType: "string" },
        { dataField: "Coreitemusage", caption: "Address - 1", dataType: "string", visible:false },
        { dataField: "Kitcodeformat", caption: "Address - 2", dataType: "string", visible:false},
        { dataField: "Autogenalternateitem", caption: "City", dataType: "string", visible:false},
        { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
        { dataField: "creationuserid", caption: "Created By", dataType: "string", visible:false},
        { dataField: "lastupdatedatetime", caption: "Last Updated", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
        { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string", visible:false},
        { dataField: "userdefinedcode1", caption: "Code 1", dataType: "string", visible:false},
        { dataField: "userdefinedcode2", caption: "Code 2", dataType: "string", visible:false},
        { dataField: "userdefinedcode3", caption: "Code 3", dataType: "string", visible:false},
        { dataField: "userdefinedcode4", caption: "Code 4", dataType: "string", visible:false},
        { dataField: "userdefinedcode5", caption: "Code 5", dataType: "string", visible:false},
        { dataField: "recordnumber", caption: "Record #", dataType: "string", visible:false}
    ]
};
const PriceCodesHeaderLookupLayout ={
    valueExpr: 'Id',
    displayExpr: 'Code',
    sort: [{ selector: "Code", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '6735CE1C-27AB-4636-B1F4-CBAB391EC9BB',
    params: {
        module: "im",
        lookupType: "PriceCodesHeader",
        showLookupGrid: true,
        isPascalCase:true,
    },
    columns: [
        { dataField: "Id", caption: "ID", dataType: "string", visible: false },
        { dataField: "Record", caption: "Record", dataType: "string"},
        { dataField: "Code", caption: "Price Code", dataType: "string" },
        { dataField: "CreationDateTime", caption: "Creation Date", dataType: "datetime", visible: false },
        { dataField: "CreationUserId", caption: "Created By", dataType: "string", visible: false },
        { dataField: "LastUpdateDateTime", caption: "Last Updated Date", dataType: "datetime", visible: false },
        { dataField: "LastUpdateUserId", caption: "Last Updated By", dataType: "string", visible: false },
        { dataField: "Description", caption: "Description", dataType: "string" },
        { dataField: "PriceBasis", caption: "Price Basis", dataType: "string", visible: false },
        { dataField: "PriceMethod", caption: "Price Method", dataType: "string", visible: false },
        { dataField: "Status", caption: "Status", dataType: "string", visible: false },
        { dataField: "Reference", caption: "Reference", dataType: "string", visible: false },
        { dataField: "Comment", caption: "Comment", dataType: "string", visible: false },
        { dataField: "NumberOfPriceLevels", caption: "Number Of Price Levels", dataType: "string", visible: false },
        { dataField: "EffectiveDateEnd", caption: "Effective Date End", dataType: "datetime", visible: false },
        { dataField: "EffectiveDateStart", caption: "Effective Date Start", dataType: "datetime", visible: false },
        { dataField: "PriceBasisAmount", caption: "Price Basis Amount", dataType: "number", visible: false },

    ]
};
const ContainerLookupLayout ={
    valueExpr: 'Id',
    displayExpr: 'Code',
    sort: [{ selector: "Code", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '6735CE1C-27AB-4636-B1F4-CBAB391EC9BB',
    params: {
        module: "im",
        lookupType: "Container",
        showLookupGrid: true,
        isPascalCase:true,
    },
    columns: [
        { dataField: "Id", caption: "Id", dataType: "string", visible: false },
        { dataField: "Record", caption: "Record", dataType: "string" },
        { dataField: "Code", caption: "Code", dataType: "string" },
        { dataField: "CreationDateTime", caption: "Creation Date Time", dataType: "datetime", visible: false },
        { dataField: "CreationUserId", caption: "Creation User Id", dataType: "string", visible: false },
        { dataField: "LastUpdateDateTime", caption: "Last Update Date Time", dataType: "datetime", visible: false },
        { dataField: "LastUpdateUserId", caption: "Last Update User Id", dataType: "string", visible: false },
        { dataField: "Status", caption: "Status", dataType: "string", visible: false },
        { dataField: "ContainerDescription", caption: "Description", dataType: "string" },
        { dataField: "PrintedContainerCode", caption: "Printed Container Code", dataType: "string", visible: false },
        { dataField: "ContainerClass", caption: "Container Class", dataType: "string", visible: false },
        { dataField: "Reference", caption: "Reference", dataType: "string", visible: false },
        { dataField: "ShippingClassificationCode", caption: "Shipping Classification Code", dataType: "string", visible: false },
        { dataField: "PackageType", caption: "Package Type", dataType: "string", visible: false },
        { dataField: "UnitOfMeasure", caption: "Unit Of Measure", dataType: "string", visible: false },
        { dataField: "WingdingUnits", caption: "Wingding Units", dataType: "string", visible: false },
        { dataField: "ContainerType", caption: "Container Type", dataType: "string", visible: false },
        { dataField: "ClassMinVolume", caption: "Class Min Volume", dataType: "string", visible: false },
        { dataField: "Volume", caption: "Volume", dataType: "string", visible: false },
        { dataField: "ContainerSort", caption: "Container Sort", dataType: "string", visible: false },
        { dataField: "Brand", caption: "Brand", dataType: "string", visible: false },
        { dataField: "BrandRequirements", caption: "Brand Requirements", dataType: "string", visible: false },
        { dataField: "Comment", caption: "Comment", dataType: "string", visible: false },
        { dataField: "Height", caption: "Height", dataType: "string", visible: false },
        { dataField: "Width", caption: "Width", dataType: "string", visible: false },
        { dataField: "Depth", caption: "Depth", dataType: "string", visible: false },
        { dataField: "TareWeightQuantity", caption: "Tare Weight Quantity", dataType: "string", visible: false },
        { dataField: "UserDefinedCode1", caption: "User Defined Code1", dataType: "string", visible: false },
        { dataField: "UserDefinedCode2", caption: "User Defined Code2", dataType: "string", visible: false },
        { dataField: "UserDefinedCode3", caption: "User Defined Code3", dataType: "string", visible: false },
        { dataField: "UserDefinedCode4", caption: "User Defined Code4", dataType: "string", visible: false },
        { dataField: "UserDefinedCode5", caption: "User Defined Code5", dataType: "string", visible: false },
        { dataField: "UserDefinedDate1", caption: "User Defined Date1", dataType: "date", visible: false },
        { dataField: "UserDefinedDate2", caption: "User Defined Date2", dataType: "date", visible: false },
        { dataField: "UserDefinedDate3", caption: "User Defined Date3", dataType: "date", visible: false },
        { dataField: "UserDefinedDate4", caption: "User Defined Date4", dataType: "date", visible: false },
        { dataField: "UserDefinedDate5", caption: "User Defined Date5", dataType: "date", visible: false },
        { dataField: "UserDefinedReference1", caption: "User Defined Reference1", dataType: "string", visible: false },
        { dataField: "UserDefinedReference2", caption: "User Defined Reference2", dataType: "string", visible: false },
        { dataField: "UserDefinedReference3", caption: "User Defined Reference3", dataType: "string", visible: false },
        { dataField: "UserDefinedReference4", caption: "User Defined Reference4", dataType: "string", visible: false },
        { dataField: "UserDefinedReference5", caption: "User Defined Reference5", dataType: "string", visible: false },
        { dataField: "UserDefinedQuantity1", caption: "User Defined Quantity1", dataType: "number", visible: false },
        { dataField: "UserDefinedQuantity2", caption: "User Defined Quantity2", dataType: "number", visible: false },
        { dataField: "UserDefinedQuantity3", caption: "User Defined Quantity3", dataType: "number", visible: false },
        { dataField: "UserDefinedQuantity4", caption: "User Defined Quantity4", dataType: "number", visible: false },
        { dataField: "UserDefinedQuantity5", caption: "User Defined Quantity5", dataType: "number", visible: false },
        { dataField: "UserDefinedComment", caption: "User Defined Comment", dataType: "string", visible: false },
        { dataField: "FreightClassCode", caption: "Freight Class Code", dataType: "string", visible: false },

    ]
};
const ItemGroupLookupLayout ={
    valueExpr: 'Id',
    displayExpr: 'Code',
    sort: [{ selector: "Code", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '6735CE1C-27AB-4636-B1F4-CBAB391EC9BB',
    params: {
        module: "im",
        lookupType: "ItemGroup",
        showLookupGrid: true,
        isPascalCase:true,
    },
    columns: [
        { dataField: "Id", caption: "Row Id", dataType: "string", visible: false },
        { dataField: "Group", caption: "Item Group", dataType: "string" },
        { dataField: "Description", caption: "Description", dataType: "string" },
        { dataField: "Member1", caption: "Member1", dataType: "string", visible: false },
        { dataField: "Member2", caption: "Member2", dataType: "string", visible: false },
        { dataField: "Member3", caption: "Member3", dataType: "string", visible: false },
        { dataField: "Member4", caption: "Member4", dataType: "string", visible: false },
        { dataField: "Member5", caption: "Member5", dataType: "string", visible: false },
        { dataField: "Member6", caption: "Member6", dataType: "string", visible: false },
        { dataField: "Member7", caption: "Member7", dataType: "string", visible: false },
        { dataField: "Member8", caption: "Member8", dataType: "string", visible: false },
        { dataField: "Member9", caption: "Member9", dataType: "string", visible: false },
        { dataField: "Member10", caption: "Member10", dataType: "string", visible: false },
        { dataField: "Member11", caption: "Member11", dataType: "string", visible: false },
        { dataField: "Member12", caption: "Member12", dataType: "string", visible: false },
        { dataField: "Member13", caption: "Member13", dataType: "string", visible: false },
        { dataField: "Member14", caption: "Member14", dataType: "string", visible: false },
        { dataField: "Member15", caption: "Member15", dataType: "string", visible: false },
        { dataField: "Member16", caption: "Member16", dataType: "string", visible: false },
        { dataField: "Member17", caption: "Member17", dataType: "string", visible: false },
        { dataField: "Member18", caption: "Member18", dataType: "string", visible: false },
        { dataField: "Member19", caption: "Member19", dataType: "string", visible: false },
        { dataField: "Member20", caption: "Member20", dataType: "string", visible: false },
        { dataField: "Comment", caption: "Comment", dataType: "string", visible: false },

    ]
};

/**
 * The location lookup behind the WM Crate Detail From/To Location dialog (WMD0049).
 *
 * Same lookup as IMLocationLookupLayout, narrowed server-side to the locations that actually hold this
 * crate line's stock - Delphi keys it on exactly one of item / lot / sub-lot / unit with Available > 0
 * (uWMD0049.PAS LocationLookup). The columns are the ones its lookup grid shows, so the operator can
 * see how much is in each location before choosing one.
 */
function IMLocationAvailabilityLookupLayout(customParams) {
    var base = IMLocationLookupLayout(customParams || {});

    return {
        valueExpr: base.valueExpr,
        displayExpr: base.displayExpr,
        sort: base.sort,
        searchEnbabled: base.searchEnbabled,
        acceptCustomValue: base.acceptCustomValue,
        // Its own grid key, so the column layout the operator saves here does not follow the plain
        // location lookup around the rest of the application.
        gridKey: '8D41B9E5-6C2A-4F17-9A3B-5E0C7D26F418',
        params: Object.assign({}, base.params, { availableOnly: true }),
        columns: [
            { dataField: "codevalue", caption: "Location", dataType: "string" },
            { dataField: "identityid", caption: "Warehouse", dataType: "string" },
            { dataField: "description", caption: "Description", dataType: "string" },
            { dataField: "available", caption: "Available", dataType: "number", format: { type: "fixedPoint", precision: 2 } },
            { dataField: "onhand", caption: "On Hand", dataType: "number", format: { type: "fixedPoint", precision: 2 } }
        ]
    };
}

export {
    IMLocationLookupLayout,
    IMLocationAvailabilityLookupLayout,
    IMKitHeaderLookupLayout,
    ImItemLookupLayout,
    IMPriceScheduleLookupLayout,
    IMProductCategoryLookupLayout,
    IMLotLookupLayout,
    IMTransactionProfileLookupLayout,
    IMFeesLookupLayout,
    CodeLookupLayout,
    LocationDpLookupLayout,
    ItemBuilderConfigLookup,
    CrateDPLookup,
    ItemDpLookupLayout,
    MandateFeesLookupLayout,
    PriceCodesHeaderLookupLayout,
    ContainerLookupLayout,
    ItemGroupLookupLayout
}